import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import LoginStepThreeEmailMobile from "../login-step-three-email-mobile/component";
import styles from "./styles.css";
import { getLeadGenerationFormConfig } from "../../../utils/helpers/get-lead-generation-form-config";

const LoggedInDealerRedirectModal = ({
    isOpen,
    handleOnClose,
    dealerName,
    onViewDealer,
    cmsConfig
}) => {

    return (
        <Modal close={handleOnClose} isOpen={isOpen} contentClass="loginWithEmailAndModal">
            <div styleName={"styles.loginModal"}>
                <div styleName={"styles.content"}>
                    <LoginStepThreeEmailMobile
                        onViewDealer={onViewDealer}
                        dealerName={dealerName}
                        leadGenConfig={getLeadGenerationFormConfig(cmsConfig)}
                        nonLogin={true}
                    />
                </div>
            </div>
        </Modal>
    );
};

LoggedInDealerRedirectModal.propTypes = {
    isOpen: PropTypes.bool,
    handleOnClose: PropTypes.func,
    dealerName: PropTypes.string,
    leadGenConfig: PropTypes.object,
    onViewDealer: PropTypes.func,
    cmsConfig: PropTypes.object,
    source: PropTypes.string
};

export default LoggedInDealerRedirectModal;
